import $ from 'jquery';
import { FireComponent } from '@component';

export class CategoryFilter extends FireComponent {
  constructor(id) {
    super(id);
  }


  get elements() {
    return {
      $category: this.findElement('category'),
    };
  }

  _initCategoryFilter() {
    this.elements.$category.on('change', function (e) {
      var $term = $(e.currentTarget).val();

      if ($term) {
        if ($term == 'blog') {
          window.location = '/blog/';
        } else {
          window.location = '/blog/' + $term;
        }
      }
      return false;
    });
  }

  init() {
    if (!this.componentExists) return;
    this._initCategoryFilter();
  }
}
